"use client";

import { useEffect } from "react";

export default function CinematicEngine() {
  useEffect(() => {
    let lenis: import("lenis").default | null = null;

    async function boot() {
      const { default: Lenis } = await import("lenis");

      const instance = new Lenis({
        duration: 1.2,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      lenis = instance;

      function raf(time: number) {
        instance.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    }

    boot();
    return () => { if (lenis) lenis.destroy(); };
  }, []);

  return null;
}
